/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import uuid from 'uuid/v4';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InfoBox, { InfoBoxSpacer } from './EnhancedGridFeature/InfoBox';
import EditToolPalette from './EnhancedGridFeature/EditToolPalette'; 
import cacPalette from '../corrCluster/enhancedFeatures/cacPalette';
import { useDispatch } from '../react-redux-hooks';
import { setCacNodeColors } from '../../actions/cacActions';


function GenericCollapsibleDropdown(props) {
  const {
    isOpen,
    title,
    data,
    showPassiveIcon,
    count,
    keyType,
    activeProjetId,
    gridType,
    toggleCollapsibleDropdown,
    addToPassive,
    showHideData,
    allowColorChange,
    nodeColors,
    projectId,
  } = props;

  const dispatch = useDispatch();

  const setNodeColors = nodeColors => {
    dispatch(setCacNodeColors(projectId, nodeColors));
  };

  const handleNodeColorClickEvent = (title, colr) => {
    const t = (title === "COLUMNS") ? 'col' : (title === "ROWS" ? 'row' : 'passive' );
    const newNodeColors = { ...nodeColors, [t] : colr.name }
    setNodeColors(newNodeColors);
  }

  const getColorName = () => {
    const name =
      title === 'COLUMNS'
        ? nodeColors.col
        : title === 'ROWS'
        ? nodeColors.row
        : nodeColors.passive;

    return name;
  }

  const getNodeRGB = () => {
    if (!nodeColors) return null;
    const name = getColorName();

    const palettes = cacPalette();
    const palette = _.find(palettes, { name });
    return palette
      ? palette.light
      : undefined;
  };


    const buildInfoBox = () => {
      const ibp = [];
      const name = getColorName();
      ibp.push(
        <InfoBoxSpacer
          Height="0.1em"
          boxClassName="toolPalette-spacer-row ibox-spacer-hline"
        />
      );
      ibp.push(
        <EditToolPalette
          title={title}
          colorName={name}
          nodeColorClick={handleNodeColorClickEvent}
        />
      );

      return ibp;
    };


  // will need to add a color selector
  const showNodeColorCircle = () => {
    return (
      getNodeRGB() && (
        <React.Fragment>
          <span className="c-table--row-infobox-ellipsis">
            <InfoBox
              Panels={buildInfoBox()}
              updatePanels={buildInfoBox}
              Positions={['right']}
              InfoBoxButtonInner={
                <span
                  className="color-indicator"
                  style={{
                    backgroundColor: getNodeRGB(),
                  }}
                />
              }
              Align="center"
              containerClassName="ibox-popover-color-pal"
            />
          </span>
        </React.Fragment>
      )
    );
  };

  return (
    <div className="collapsible-dropdown">
      <div
        className={
          count > 5
            ? 'padding-right-10 collapsible-dropdown-header'
            : 'collapsible-dropdown-header'
        }
      >
        <span
          onClick={() => toggleCollapsibleDropdown(keyType, activeProjetId)}
          role="button"
          tabIndex={0}
        >
          <span className={`${isOpen ? 'open-dropdown icon' : 'icon'}`} />
          <label className="headerTitle">{title}</label>
          <label className="count"> ({count})</label>
        </span>
        {allowColorChange ? (
          showNodeColorCircle()
        ) : (
          <span
            className="color-indicator"
            style={{
              backgroundColor: getNodeRGB(),
            }}
          />
        )}
      </div>
      {isOpen ? (
        <div className="collapsible-dropdown-menuItem">
          {data.map((item, index) => {
            return (
              <div key={uuid()} title={item.title}>
                <label
                  s
                  className={
                    (item.isPassive && showPassiveIcon) || !item.isShow
                      ? 'passiveEnabled'
                      : ''
                  }
                >
                  {item.title}
                </label>
                {showPassiveIcon ? (
                  <span className="radio-toggle">
                    <label
                      className={
                        !item.isPassive
                          ? 'rb-switcher blue'
                          : 'disble_switch rb-switcher gray'
                      }
                      htmlFor={`${item.keyword}_${gridType}`}
                    >
                      <input
                        type="checkbox"
                        name={`${item.keyword}_${gridType}`}
                        id={`${item.keyword}_${gridType}`}
                        checked={item.isShow}
                        disabled={item.isPassive}
                        onChange={() =>
                          // onClick creates a warning in the Console
                          showHideData(
                            gridType,
                            activeProjetId,
                            index,
                            !item.isShow
                          )
                        }
                      />{' '}
                      <i />
                    </label>
                  </span>
                ) : (
                  () => {}
                )}
                {showPassiveIcon ? (
                  <span
                    className={
                      !item.isShow
                        ? 'passiveIcon disableIcon'
                        : item.isPassive
                        ? 'passiveIcon enabled'
                        : 'passiveIcon'
                    }
                    onClick={() =>
                      addToPassive(
                        gridType,
                        activeProjetId,
                        index,
                        item.isPassive
                      )
                    }
                    role="button"
                    tabIndex={0}
                  >
                    P
                  </span>
                ) : (
                  () => {}
                )}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

GenericCollapsibleDropdown.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.shape({})]),
  showPassiveIcon: PropTypes.bool,
  count: PropTypes.number,
  keyType: PropTypes.string,
  activeProjetId: PropTypes.number,
  toggleCollapsibleDropdown: PropTypes.func,
  addToPassive: PropTypes.func,
  gridType: PropTypes.string,
  showHideData: PropTypes.func,
  allowColorChange: PropTypes.bool,
  nodeColors: PropTypes.shape({
    col: PropTypes.string,
    row: PropTypes.string,
    passive: PropTypes.string,
  }),
  projectId: PropTypes.number,
};

export default GenericCollapsibleDropdown;
